function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.89543 24 0 23.1046 0 22V2Z",
  fill: "#FDFDFD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9148 5.81818H16.1477V12.5597C16.1477 13.2557 15.9837 13.8771 15.6555 14.424C15.3307 14.9676 14.8717 15.3968 14.2784 15.7116C13.6851 16.0232 12.9891 16.179 12.1903 16.179C11.3916 16.179 10.6955 16.0232 10.1023 15.7116C9.509 15.3968 9.0483 14.9676 8.72017 14.424C8.39536 13.8771 8.23295 13.2557 8.23295 12.5597V5.81818H9.46591V12.4602C9.46591 12.9574 9.57528 13.3999 9.79403 13.7876C10.0128 14.1721 10.3243 14.4754 10.7287 14.6974C11.1364 14.9162 11.6236 15.0256 12.1903 15.0256C12.7571 15.0256 13.2443 14.9162 13.652 14.6974C14.0597 14.4754 14.3712 14.1721 14.5866 13.7876C14.8054 13.3999 14.9148 12.9574 14.9148 12.4602V5.81818Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7 18.7841H17.3807V19.7386H7V18.7841Z",
  fill: "black"
});

function SvgUnderline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.b5438aab.svg";
export { ForwardRef as ReactComponent };